import { extendTheme } from '@chakra-ui/react';
import { theme as programDefaultsTheme } from '@frx/frx-program-defaults';

const overrides = {};

export const programTheme = extendTheme(programDefaultsTheme, overrides);
